import React from 'react';

interface SearchTextboxWrapperProps {
  children: React.ReactNode;
  onSearchClick?: () => void;
  searchIcon: React.ReactNode;
  className?: string;
}

export const SearchTextboxWrapper: React.FC<SearchTextboxWrapperProps> = ({
  children,
  onSearchClick,
  searchIcon,
  className = '',
}) => {
  return (
    <div
      className={`search-textbox-wrapper ${className}`}
      style={{ position: 'relative' }}
    >
      {children}
      <div
        className="search-icon-container"
        onClick={onSearchClick}
        style={{
          position: 'absolute',
          right: '8px',
          top: '75%',
          transform: 'translateY(-50%)',
          cursor: onSearchClick ? 'pointer' : 'default',
          zIndex: 1,
          display: 'flex',
          alignItems: 'center',
          height: '20px',
        }}
      >
        {searchIcon}
      </div>
      <style>{`
        .search-textbox-wrapper input {
          padding-right: 35px !important;
        }

        .search-icon-container:hover {
          opacity: ${onSearchClick ? '0.7' : '1'};
        }
      `}</style>
    </div>
  );
};
